import React from 'react';

export interface StepLimitWarningBannerProps {
  className?: string;
}

export function StepLimitWarningBanner({
  className = '',
}: StepLimitWarningBannerProps) {
  return (
    <div
      role='alert'
      data-testid='step-limit-warning-banner'
      data-component='banner'
      data-instance='step-limit-warning'
      className={`rounded-xl px-4 py-3 ${className}`}
      style={{ backgroundColor: 'var(--color-bg-warning-secondary)' }}
    >
      <p
        className='text-sm'
        style={{ color: 'var(--color-text-warning-primary)' }}
      >
        This response may be incomplete – the agent reached its processing
        limit.
      </p>
    </div>
  );
}

export default StepLimitWarningBanner;
